// Approximate center coordinates for DXCC entities
// Used as fallback when QSO has no grid square
export var ENTITY_COORDS = {
"United States":{"lat":39.8,"lon":-98.6},"Canada":{"lat":56.1,"lon":-106.3},"Mexico":{"lat":23.6,"lon":-102.5},
"Brazil":{"lat":-14.2,"lon":-51.9},"Argentina":{"lat":-38.4,"lon":-63.6},"Chile":{"lat":-35.7,"lon":-71.5},
"Colombia":{"lat":4.6,"lon":-74.3},"Venezuela":{"lat":6.4,"lon":-66.6},"Peru":{"lat":-9.2,"lon":-75.0},
"Uruguay":{"lat":-32.5,"lon":-55.8},"Paraguay":{"lat":-23.4,"lon":-58.4},"Bolivia":{"lat":-16.3,"lon":-63.6},
"Ecuador":{"lat":-1.8,"lon":-78.2},"Guyana":{"lat":4.9,"lon":-58.9},"Suriname":{"lat":3.9,"lon":-56.0},
"French Guiana":{"lat":3.9,"lon":-53.1},"Cuba":{"lat":21.5,"lon":-79.0},"Jamaica":{"lat":18.1,"lon":-77.3},
"Haiti":{"lat":19.1,"lon":-72.3},"Dominican Republic":{"lat":18.7,"lon":-70.2},
"Puerto Rico":{"lat":18.2,"lon":-66.6},"Trinidad & Tobago":{"lat":10.7,"lon":-61.2},
"Bahamas":{"lat":25.0,"lon":-77.4},"Barbados":{"lat":13.2,"lon":-59.5},"Bermuda":{"lat":32.3,"lon":-64.8},
"United Kingdom":{"lat":55.4,"lon":-3.4},"England":{"lat":52.4,"lon":-1.2},"Scotland":{"lat":56.5,"lon":-4.2},
"Wales":{"lat":52.1,"lon":-3.8},"Northern Ireland":{"lat":54.8,"lon":-6.5},
"Germany":{"lat":51.2,"lon":10.5},"France":{"lat":46.2,"lon":2.2},"Spain":{"lat":40.5,"lon":-3.7},
"Italy":{"lat":41.9,"lon":12.6},"Portugal":{"lat":39.4,"lon":-8.2},"Netherlands":{"lat":52.1,"lon":5.3},
"Belgium":{"lat":50.5,"lon":4.5},"Switzerland":{"lat":46.8,"lon":8.2},"Austria":{"lat":47.5,"lon":14.6},
"Poland":{"lat":51.9,"lon":19.1},"Czech Republic":{"lat":49.8,"lon":15.5},"Sweden":{"lat":60.1,"lon":18.6},
"Norway":{"lat":60.5,"lon":8.5},"Denmark":{"lat":56.3,"lon":9.5},"Finland":{"lat":61.9,"lon":25.7},
"Ireland":{"lat":53.1,"lon":-7.7},"Greece":{"lat":39.1,"lon":21.8},"Turkey":{"lat":39.0,"lon":35.2},
"Romania":{"lat":45.9,"lon":25.0},"Hungary":{"lat":47.2,"lon":19.5},"Bulgaria":{"lat":42.7,"lon":25.5},
"Serbia":{"lat":44.0,"lon":21.0},"Croatia":{"lat":45.1,"lon":15.2},"Ukraine":{"lat":48.4,"lon":31.2},
"European Russia":{"lat":55.8,"lon":37.6},"Asiatic Russia":{"lat":60.0,"lon":100.0},
"Russia":{"lat":55.8,"lon":37.6},"Belarus":{"lat":53.7,"lon":27.95},"Lithuania":{"lat":55.2,"lon":24.0},
"Latvia":{"lat":56.9,"lon":24.1},"Estonia":{"lat":58.6,"lon":25.0},"Moldova":{"lat":47.4,"lon":28.4},
"Slovakia":{"lat":48.7,"lon":19.7},"Slovenia":{"lat":46.2,"lon":14.8},"Bosnia-Herzegovina":{"lat":43.9,"lon":17.7},
"Montenegro":{"lat":42.7,"lon":19.4},"North Macedonia":{"lat":41.5,"lon":21.7},"Albania":{"lat":41.2,"lon":20.2},
"Kosovo":{"lat":42.6,"lon":21.0},"Luxembourg":{"lat":49.8,"lon":6.1},"Liechtenstein":{"lat":47.2,"lon":9.6},
"Monaco":{"lat":43.7,"lon":7.4},"Malta":{"lat":35.9,"lon":14.4},"Cyprus":{"lat":35.1,"lon":33.4},
"Iceland":{"lat":65.0,"lon":-19.0},"Greenland":{"lat":72.0,"lon":-40.0},
"Japan":{"lat":36.2,"lon":138.3},"China":{"lat":35.9,"lon":104.2},"South Korea":{"lat":35.9,"lon":128.0},
"Republic of Korea":{"lat":35.9,"lon":128.0},"Taiwan":{"lat":23.7,"lon":121.0},
"India":{"lat":20.6,"lon":79.0},"Thailand":{"lat":15.9,"lon":100.5},"Indonesia":{"lat":-0.8,"lon":113.9},
"Philippines":{"lat":12.9,"lon":121.8},"Vietnam":{"lat":14.1,"lon":108.3},"Malaysia":{"lat":4.2,"lon":101.9},
"Singapore":{"lat":1.4,"lon":103.9},"Pakistan":{"lat":30.4,"lon":69.3},"Bangladesh":{"lat":23.7,"lon":90.4},
"Sri Lanka":{"lat":7.9,"lon":80.8},"Israel":{"lat":31.0,"lon":34.9},"Saudi Arabia":{"lat":23.9,"lon":45.1},
"United Arab Emirates":{"lat":23.4,"lon":53.8},"Kuwait":{"lat":29.3,"lon":47.5},"Qatar":{"lat":25.4,"lon":51.2},
"Oman":{"lat":21.5,"lon":55.9},"Bahrain":{"lat":26.1,"lon":50.6},"Jordan":{"lat":30.6,"lon":36.2},
"Iraq":{"lat":33.2,"lon":43.7},"Iran":{"lat":32.4,"lon":53.7},"Kazakhstan":{"lat":48.0,"lon":68.0},
"Uzbekistan":{"lat":41.4,"lon":64.6},"Mongolia":{"lat":46.9,"lon":103.8},"Georgia":{"lat":42.3,"lon":43.4},
"Armenia":{"lat":40.1,"lon":45.0},"Azerbaijan":{"lat":40.1,"lon":47.6},
"Australia":{"lat":-25.3,"lon":133.8},"New Zealand":{"lat":-40.9,"lon":174.9},
"Papua New Guinea":{"lat":-6.3,"lon":143.9},"Fiji":{"lat":-18.0,"lon":179.0},
"Hawaii":{"lat":19.9,"lon":-155.6},"Alaska":{"lat":64.2,"lon":-152.5},
"South Africa":{"lat":-30.6,"lon":22.9},"Nigeria":{"lat":9.1,"lon":8.7},
"Kenya":{"lat":-0.0,"lon":37.9},"Egypt":{"lat":26.8,"lon":30.8},"Morocco":{"lat":31.8,"lon":-7.1},
"Tunisia":{"lat":33.9,"lon":9.5},"Algeria":{"lat":28.0,"lon":1.7},"Ghana":{"lat":7.9,"lon":-1.0},
"Tanzania":{"lat":-6.4,"lon":34.9},"Uganda":{"lat":1.4,"lon":32.3},"Ethiopia":{"lat":9.1,"lon":40.5},
"Mozambique":{"lat":-18.7,"lon":35.5},"Angola":{"lat":-11.2,"lon":17.9},"Madagascar":{"lat":-18.8,"lon":47.5},
"Senegal":{"lat":14.5,"lon":-14.5},"Cameroon":{"lat":7.4,"lon":12.4},"Ivory Coast":{"lat":7.5,"lon":-5.5},
"Mauritius":{"lat":-20.3,"lon":57.6},"Reunion":{"lat":-21.1,"lon":55.5},"Canary Islands":{"lat":28.1,"lon":-15.4},
"Azores":{"lat":38.7,"lon":-27.2},"Madeira Islands":{"lat":32.7,"lon":-17.0},
"Cape Verde":{"lat":16.0,"lon":-24.0},"Eswatini":{"lat":-26.5,"lon":31.5},
"Costa Rica":{"lat":9.7,"lon":-83.8},"Panama":{"lat":8.5,"lon":-80.8},"Honduras":{"lat":15.2,"lon":-86.2},
"Guatemala":{"lat":15.8,"lon":-90.2},"El Salvador":{"lat":13.8,"lon":-88.9},"Nicaragua":{"lat":12.9,"lon":-85.2},
"Belize":{"lat":17.2,"lon":-88.5},"Aruba":{"lat":12.5,"lon":-70.0},"Curacao":{"lat":12.2,"lon":-69.0},
"Bonaire":{"lat":12.1,"lon":-68.3},"Guadeloupe":{"lat":16.3,"lon":-61.6},"Martinique":{"lat":14.6,"lon":-61.0},
"Sov. Mil. Order of Malta":{"lat":41.9,"lon":12.5},"Fed. Rep. of Germany":{"lat":51.2,"lon":10.5},
"Balearic Islands":{"lat":39.7,"lon":3.0},"Sardinia":{"lat":39.2,"lon":9.0},"Corsica":{"lat":42.0,"lon":9.0},
"Sicily":{"lat":37.6,"lon":14.0},"Crete":{"lat":35.2,"lon":24.9},"Svalbard":{"lat":78.0,"lon":16.0},
"Aland Islands":{"lat":60.2,"lon":20.0},"Jan Mayen":{"lat":71.0,"lon":-8.5},
"Asiatic Turkey":{"lat":39.0,"lon":35.0},"European Turkey":{"lat":41.0,"lon":28.6},
"Russian Federation":{"lat":55.8,"lon":37.6},
"Slovak Republic":{"lat":48.7,"lon":19.7},
"Fed. Rep. of Germany":{"lat":51.2,"lon":10.5},
"Republic of Korea":{"lat":35.9,"lon":128},
"Cote d Ivoire":{"lat":7.5,"lon":-5.5},
"Sao Tome and Principe":{"lat":0.2,"lon":6.6},
"Central African Rep.":{"lat":6.6,"lon":20.9},
"Republic of the Congo":{"lat":-0.2,"lon":15.8},
"Antigua and Barbuda":{"lat":17.1,"lon":-61.8},
"St. Kitts and Nevis":{"lat":17.4,"lon":-62.7},
"Trinidad and Tobago":{"lat":10.7,"lon":-61.2},
"Turks and Caicos Is.":{"lat":21.7,"lon":-71.8},
"Falkland Is.":{"lat":-51.8,"lon":-59.6},
"Balearic Is.":{"lat":39.7,"lon":3},
"Canary Is.":{"lat":28.1,"lon":-15.4},
"Ceuta and Melilla":{"lat":35.9,"lon":-5.3},
"Faroe Is.":{"lat":62,"lon":-7},
"Marshall Is.":{"lat":7.1,"lon":171.2},
"Solomon Is.":{"lat":-9.6,"lon":160.2},
"Norfolk Is.":{"lat":-29.0,"lon":167.9},
"Christmas Is.":{"lat":-10.5,"lon":105.7},
"Mariana Is.":{"lat":15.2,"lon":145.7},
"American Samoa":{"lat":-14.3,"lon":-170.1},
"US Virgin Is.":{"lat":18.3,"lon":-64.9},
"Galapagos Is.":{"lat":-0.9,"lon":-89.6},
"Fernando de Noronha":{"lat":-3.9,"lon":-32.4},
"Kaliningrad":{"lat":54.7,"lon":20.5},
"San Marino":{"lat":43.9,"lon":12.4},
"Vatican":{"lat":41.9,"lon":12.5},
"Dodecanese":{"lat":36.4,"lon":28.2},
"Pitcairn Is.":{"lat":-25.1,"lon":-130.1},
"Hong Kong":{"lat":22.4,"lon":114.1},
"Macao":{"lat":22.2,"lon":113.5},
"Guam":{"lat":13.4,"lon":144.8},
"Palau":{"lat":7.5,"lon":134.6},
"Tuvalu":{"lat":-8.5,"lon":179.2},
"Vanuatu":{"lat":-15.4,"lon":166.9},
"Guinea-Bissau":{"lat":12,"lon":-15},
"Dominica":{"lat":15.4,"lon":-61.4},
"Grenada":{"lat":12.1,"lon":-61.7},
"St. Lucia":{"lat":13.9,"lon":-61},
"St. Vincent":{"lat":13.3,"lon":-61.2},
"Djibouti":{"lat":11.6,"lon":43.1},
"Eritrea":{"lat":15.2,"lon":39.8},
"Comoros":{"lat":-12.2,"lon":44.3},
"Seychelles":{"lat":-4.7,"lon":55.5},
"Mayotte":{"lat":-12.8,"lon":45.2},
"New Caledonia":{"lat":-22.3,"lon":166.5},
"French Polynesia":{"lat":-17.7,"lon":-149.4},
"Wallis and Futuna":{"lat":-13.3,"lon":-176.2},
"St. Pierre and Miquelon":{"lat":46.9,"lon":-56.3},
"Saint Martin":{"lat":18.1,"lon":-63},
"Sint Maarten":{"lat":18.1,"lon":-63},
"Anguilla":{"lat":18.2,"lon":-63},
"Montserrat":{"lat":16.7,"lon":-62.2},
"Cayman Is.":{"lat":19.3,"lon":-81.3},
"Guantanamo Bay":{"lat":20,"lon":-75.1},
"Brunei":{"lat":4.9,"lon":114.9},
"Micronesia":{"lat":6.9,"lon":158.2},
"Namibia":{"lat":-22.6,"lon":17.1},
"Zimbabwe":{"lat":-19.0,"lon":29.2},
"South Sudan":{"lat":6.9,"lon":31.3},
"Gibraltar":{"lat":36.1,"lon":-5.4},
"St. Helena":{"lat":-15.9,"lon":-5.7},
"Ascension Is.":{"lat":-7.9,"lon":-14.4},
"Kyrgyzstan":{"lat":41,"lon":74.8},
"Tajikistan":{"lat":38.9,"lon":71.3},
"Turkmenistan":{"lat":38.9,"lon":59.6},
"Myanmar":{"lat":19.7,"lon":96.1},
"Cambodia":{"lat":11.6,"lon":105},
"Laos":{"lat":19.9,"lon":102.5},
"Syria":{"lat":34.8,"lon":39},
"Lebanon":{"lat":33.9,"lon":35.5},
"Afghanistan":{"lat":33,"lon":65},
"Benin":{"lat":9.3,"lon":2.3},
"Burkina Faso":{"lat":12.3,"lon":-1.6},
"Chad":{"lat":15.5,"lon":19},
"Gabon":{"lat":-0.8,"lon":11.6},
"Mali":{"lat":17.6,"lon":-4},
"Niger":{"lat":17.6,"lon":8.1},
"Togo":{"lat":8.6,"lon":1.2},
"Liberia":{"lat":6.4,"lon":-9.4},
"Guinea":{"lat":9.9,"lon":-9.7},
"Sudan":{"lat":15.5,"lon":32.5},
"Somalia":{"lat":5.2,"lon":46.2},
"Samoa":{"lat":-13.8,"lon":-172.1},
"Equatorial Guinea":{"lat":1.6,"lon":10.3}
};

// Lookup function - returns {lat,lon} or null
export function getEntityCoords(entity) {
  if (!entity || entity === "Unknown") return null;
  return ENTITY_COORDS[entity] || null;
}
